export const INFO_API_ENDPOINT = process.env.REACT_APP_INFO_API_ENDPOINT

/**
 *  Get single Mole
 *
 *  ex: ENDPOINT/mole/metas/1
 */
export const GET_MOLE = `mole/metas`
/**
 *  Get Moles
 *
 *  ex: ENDPOINT/mole/metas/ids?id=1&id=2
 */
export const GET_MOLES = `mole/metas/ids`
